export default __webpack_public_path__ + "static/media/problema-02.235ae4d9.webp";